import brand from 'shared/app/model/branding';
function getTotalScrollY(element) {
    let totalScrollY = 0;
    let current = element;
    while (current != null) {
        totalScrollY += current.scrollTop;
        current = current.parentElement;
    }
    return totalScrollY;
}
export function elementIsInsideClassNames(element, classnames) {
    let current = element;
    while (current != null) {
        for (const classname of classnames)
            if (current.classList.contains(classname))
                return true;
        current = current.parentElement;
    }
    return false;
}
const easeOutQuad = (t) => t * (2 - t);
const clampedEasingFunction = (t) => easeOutQuad(Math.max(0, Math.min(1, t)));
let active = false;
let globalOptions;
let initialScrollY = 0;
let initialTouchY = 0;
let willRefresh = false;
let refreshing = false;
let indicator;
let arc;
let arrow;
let arcAndArrow;
function updateIndicator(progress, refreshing) {
    indicator.style.transform = `translateY(${progress * 128}px)`;
    const arrowProgress = refreshing ? 1 : progress;
    const startAngle = -Math.PI / 2 + ((arrowProgress * Math.PI) / 2) * 1.85;
    const endAngle = -Math.PI / 2 + arrowProgress * Math.PI * 2.5;
    const radius = 9;
    arc.setAttribute('d', `
      M ${Math.cos(startAngle) * radius} ${Math.sin(startAngle) * radius}
      A ${radius} ${radius} 0 ${endAngle - startAngle > Math.PI ? 1 : 0} 1 ${Math.cos(endAngle) * radius} ${Math.sin(endAngle) * radius}
      `);
    arrow.setAttribute('transform', `rotate(${(endAngle / Math.PI) * 180})`);
    arc.style.opacity = arrow.style.opacity = (0.3 + arrowProgress * 0.7).toString();
    if (refreshing)
        arcAndArrow.classList.add('refreshing');
    else
        arcAndArrow.classList.remove('refreshing');
}
function resetIndicator() {
    indicator.style.transform = '';
}
function onTouchStart(event) {
    if (event.target == null)
        return;
    if (refreshing)
        return;
    if (globalOptions?.shouldActivateOnElement)
        if (!globalOptions.shouldActivateOnElement(event.target)) {
            active = false;
            return;
        }
    active = true;
    initialScrollY = getTotalScrollY(event.target);
    initialTouchY = event.touches[0].clientY;
    willRefresh = false;
}
function onTouchMove(event) {
    if (!active)
        return;
    const scrollY = getTotalScrollY(event.target);
    if (scrollY === 0) {
        const delta = event.touches[0].clientY - initialTouchY - initialScrollY - 46;
        indicator.style.transform = `translateY(${clampedEasingFunction(delta)}px)`;
        const progress = clampedEasingFunction(delta / 128);
        willRefresh = delta > 100;
        updateIndicator(progress, false);
    }
    else {
        resetIndicator();
        willRefresh = false;
    }
}
function onTouchEnd( /* event: TouchEvent */) {
    if (!active)
        return;
    active = false;
    if (willRefresh) {
        willRefresh = false;
        updateIndicator(1, true);
        refreshing = true;
        globalOptions?.onRefresh().finally(() => {
            refreshing = false;
            const start = new Date().getTime();
            const end = new Date().getTime() + 0.2e3;
            const onFrame = () => {
                const now = new Date().getTime();
                const progress = Math.min(Math.max((end - now) / (end - start), 0), 1);
                updateIndicator(progress, true);
                if (now < end)
                    requestAnimationFrame(onFrame);
                else
                    resetIndicator();
            };
            window.setImmediate(() => requestAnimationFrame(onFrame));
        });
    }
    else
        resetIndicator();
}
export function initPullToRefresh(options) {
    globalOptions = options;
    indicator = document.createElement('div');
    indicator.setAttribute('id', 'pull-to-refresh');
    indicator.innerHTML = `
        <svg width="36" height="36">
          <g id="all">
              <g transform="translate(18, 18)">
                  <path
                    id="arc"
                    fill="none"
                    stroke="${brand.colors.helper_background}"
                    stroke-width="3"
                  />
                  <g id="arrow">
                    <path d="M 14 0 L 9 6 L 4 0 Z" fill="${brand.colors.helper_background}" stroke="none"/>
                  </g>
              </g>
          </g>
        </svg>
    `;
    arc = indicator.querySelector('#arc');
    arrow = indicator.querySelector('#arrow');
    arcAndArrow = indicator.querySelector('#all');
    document.body.appendChild(indicator);
    const style = document.createElement('style');
    style.innerText = `
        body {
            overscroll-behavior: none;
        }
        
        
        #pull-to-refresh {
            z-index: 99999;
            position: absolute;
            left: 50%;
            margin-left: -18px;
            top: -46px;
            width: 36px;
            height: 36px;
            border-radius: 100%;

            background: #fff;
            box-shadow: 0 1px 2px rgba(0,0,0,0.2), 0 1px 6px rgba(0,0,0,0.4);
            
            transition: background-color 0.2s;
        }
        
        #pull-to-refresh #all.refreshing {
            transform-origin: center;
            animation-name: rotate;
            animation-duration: 1s;
            animation-iteration-count: infinite;
            animation-timing-function: ease-in-out;
        }
        
        @keyframes rotate {
            from {
                transform: rotate(0);
            }
        
            to {
                transform: rotate(360deg);
            }
        }
    `;
    document.head.appendChild(style);
    document.addEventListener('touchstart', onTouchStart);
    document.addEventListener('touchmove', onTouchMove);
    document.addEventListener('touchend', onTouchEnd);
}
